/**
 * We split a single widget called WidgetTypes.PockMessagesOverLay
 * into 3 small classes according to their Roles: Model, View Controller
 *
 * */
import TempCache from '../core/enums/TempCache';
import BaseClass from '../core/BaseClass';
import WidgetTypes from '../core/enums/WidgetTypes';
import getStorageAPIValue from '../core/hooks/getStorageAPIValue';
import storageAPIExists from '../core/hooks/storageAPIExists';
import logIt from '../../logIt';

export default class PokeMessagesUIController extends BaseClass {
    constructor(options) {
        super(options);
        const me = this;
        me.widget = WidgetTypes.PokeMessagesOverLay;
        me.model = options.model;
        me.view = options.view;
        me.view.setModel(me.model);
        logIt('PokeMessagesUIController init');
    }

    show() {
        const me = this;
        me.view.show();
    }

    addPokeMessage(pokeMessage) {
        const me = this;
        logIt('PokeMessage');
        logIt(JSON.stringify(pokeMessage));
        // extracting the last respond time of visitor via PokeOverLay Button
        if (storageAPIExists(TempCache.POKE_MESSAGE_LastJoinBackTime)) {
            const lastJoinBackTime = parseInt(
                getStorageAPIValue(TempCache.POKE_MESSAGE_LastJoinBackTime)
            );
            // If the message createdOn time is less than last respond time, we dont need to show previously shown poke messages.
            if (pokeMessage.createdOn.getTime() < lastJoinBackTime) {
                return;
            }
        }
        // me.model.addPokeMessage(pokeMessage);//adding a PM in an array is not utilized currently; so commenting out for brevity
        me.show(); // show overley if not shown already.
        me.view.render(pokeMessage);
    }
}
